// extracted by mini-css-extract-plugin
module.exports = {"search-form":"search-form_DEFuy","left-align":"left-align_1s2Te","currencyCode":"currencyCode_2iyze"};